<script setup>
import { useLayoutStore } from '@/stores/layout.js'

import ProgressSpinner from '@/volt/ProgressSpinner.vue';
const layoutStore = useLayoutStore();

</script>

<template>
    <div class="w-full" :class="layoutStore.minimisedSidebar ? 'xl:ps-0' : 'xl:ps-72'">
        <div
            v-if="layoutStore.settings.pageLoadingIndicator"
            class="fixed inset-0 z-50 flex items-center justify-center bg-navy-900/20 backdrop-blur-xl"
        >
            <div class="bg-surface-0 dark:bg-surface-800 rounded-lg shadow-lg p-24 flex flex-col items-center gap-4">
                <ProgressSpinner />
                <span class="text-surface-500 dark:text-surface-300 text-sm font-medium tracking-wide">Loading page...</span>
            </div>
        </div>
        <!-- v-show goes on a real element, not on RouterView.
             A runtime directive needs a single root element to act on, and a
             route component is free to render several (BasePageRenderer renders
             a heading, a legacy branch and a container). Vue warns "Runtime
             directive used on component with non-element root node" and the
             directive silently does nothing, so the loading overlay never hid
             the page beneath it. -->
        <div v-show="!layoutStore.settings.pageLoadingIndicator" class="w-full">
            <RouterView />
        </div>
    </div>
</template>
